<template>
  <div class="landing">
    <div class="landing__header">
      <div class="landing__header--logo">{{ $t('landing.name')}}</div>
      <div class="landing__header--navigation">
        <!-- <div class="landing__header--navigation__element">Pobierz</div> -->
        <!-- <div class="landing__header--navigation__element">O apli</div> -->
      </div>
    </div>
    <div class="landing__body">
      <div class="landing__body--section about">
        <div style="width: 50%;">s
          <div class="landing__body--section__header">{{ $t('landing.desktop.title')}}</div>
          <div class="landing__body--section__text">
            {{ $t('landing.desktop.about')}}
          </div>
          <img class="mr-5" src="@/assets/qr.png" width="250"
            style="margin-bottom: 150px; margin-top: 20px;">
          <!-- <div class="landing__body--section__button">Pobierz aplikację</div> -->
        </div>
        <div class="landing__body--section__img">
          <img class="mr-5" src="@/assets/app-view-min.png" width="350">
        </div>
      </div>

    <div class="landing__footer">{{ $t('team')}}</div>
  </div>
  </div>
</template>

<script>
export default {
};
</script>

<style scoped lang='scss'>
.landing {
  background: $background-light-color;

  &__header {
    width: 100vw;
    top: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    padding: 40px 30px;
    color: $font-dark-color;

    &--logo {
      font-size: 3.5rem;
    }
    &--navigation {
      display: flex;
      align-items: center;
      &__element {
        margin: 0 20px;
      }
    }
  }

  &__body {
    .about {
      background: $background-light-color;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &--section {
      text-align: center;
      padding: 20px 0;
      &__header{
        font-size: 6rem;
        margin-bottom: 2.4rem;
        font-weight: 700;
        text-align: left;
        line-height: 1;
        color: $font-dark-color;
      }
      &__text {
        font-size: 2.5rem;
        margin: 0 auto;
        text-align: left;
        line-height: 1.5;
        font-weight: 100;
      }
      &__img {
      }
      &__button {
        font-weight: 600;
        font-size: 1.4rem;
        text-align: center;
        padding: 25px 25px;
        margin-top: 30px;
        border-radius: 15px;
        background: $background-brand-color;
        color: $font-light-color;
        width: 250px;
        cursor: pointer;
        -webkit-user-select: none; /* Safari */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* IE10+/Edge */
        user-select: none; /* Standard */
      }
    }
  }
  &__footer {
    width: 100vw;
    position: fixed;
    padding: 40px;
    bottom: 0;
    background: $background-light-color;
  }
}
</style>
